import { Button, Icon } from 'semantic-ui-react'
import Support from 'xAppLib/UIelems/Support'
import user_model from 'models/user_model'
import org_model from "../../models/org_model";
import {Link} from "react-router";

 
const SupportActions = _ => {
	
	if (!app.state.loaded)
		return null

	const COSM_COMPLICATIONS_ROUTE = `capture-complication`

	const isPrescriberRole = (app.acl.is_nurse || app.acl.is_leg_oper || app.acl.is_doc_presc) && !app.acl.is_admin;

	return <div className='support-actions' >
        
                <div>
				

				{ !user_model.check_access('show_support') && !app.settings.icosm && (app.settings.is_cbls || app.settings.is_cmg) &&
					<Button
							className="support-button" compact size="large" color="orange" icon="talk" content_="Contact Us"
							onClick={ _=> app.trigger( app.events.SHOW_POPUP, {
																				"tp": "pu",
																				"pt": "contact",
																				"txt": "Contact Us",
																				"u": "contact-us"
																		} )	}
						/>
				}

				{ user_model.check_access('show_support') &&
					<Support />
				}

				{isPrescriberRole  && (
					<div className={'ml-2'}>
						<Link to={COSM_COMPLICATIONS_ROUTE}>
							<Button className="!bg-icosm-tertiary support-button !text-white" compact size_="large" data-testid="button-capture-compl" icon>
								Capture Complication <Icon name="exclamation circle" />
							</Button>
						</Link>
					</div>
				)}

                </div>

			</div>
};

export default SupportActions
